import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import HomePage from './HomePage'; // o dove si trova la home
import UploadPage from './UploadPage';
import DetachedLoginPage from './DetachedLoginPage';
import ProjectPage from './ProjectPage'; // 👈 importa il componente

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/upload" element={<UploadPage />} />
        <Route path="/login" element={<DetachedLoginPage />} />
        <Route path="/:slug" element={<ProjectPage />} /> {/* 👈 route dinamica */}
      </Routes>
    </Router>
  );
}

export default App;
